import {
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_FAILED,
  INGESTION_SUCCESS,
  INGESTION_FAILED,
  ADDED_FILE_ID_TO_REDUX,
  IS_INGESTING,
  INGESTION_STATE_RESET,
  ALL_KNOWLEDGE_BASE_STATE_RESET,
  GET_FILES_SUCCESS,
  GET_FILES_FAILED,
  FOLDER_UPLOAD_SUCCESS,
  FOLDER_UPLOAD_FAILED,
  FOLDER_INGESTION_SUCCESS,
  FOLDER_INGESTION_FAILED,
  IS_FOLDER_INGESTING,
  FOLDER_INGESTION_STATE_RESET,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILED,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAILED,
  REPLACE_DOCUMENT_SUCCESS,
  REPLACE_DOCUMENT_FAILED,
} from "./Types";
import axios from "./Axios";
import { returnErrors } from "./Errors";

export const UploadAndIngestFile = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/file-transfer/upload-and-ingest/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    dispatch({ type: FILE_UPLOAD_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    console.error("Upload and ingest failed:", err.response?.data || err.message);
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: FILE_UPLOAD_FAILED });
    throw err;
  }
};

export const UploadFileKnowledgeBase = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/file-transfer/upload/`,
      formData,
      config
    );

    dispatch({
      type: FILE_UPLOAD_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    console.error("File upload failed:", err.response?.data || err.message);

    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: FILE_UPLOAD_FAILED,
    });
    throw err;
  }
};

export const IngestData = (fileID) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/file-transfer/ingest/${fileID}/`);

    dispatch({
      type: INGESTION_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    console.error("Ingestion failed:", err.response?.data || err.message);

    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: INGESTION_FAILED,
    });
    throw err;
  }
};

export const addFileIDToRedux = (fileID) => async (dispatch) => {
  dispatch({
    type: ADDED_FILE_ID_TO_REDUX,
    payload: fileID,
  });
};

export const IsIngesting = (ingestState) => async (dispatch) => {
  dispatch({
    type: IS_INGESTING,
    payload: ingestState,
  });
};

export const resetIngested = () => async (dispatch) => {
  dispatch({
    type: INGESTION_STATE_RESET,
    payload: null,
  });
};

export const resetAllKnowledgeBaseBuilder = () => async (dispatch) => {
  dispatch({
    type: ALL_KNOWLEDGE_BASE_STATE_RESET,
    payload: null,
  });
};

export const getFiles =
  (page = 1, department = null) =>
  async (dispatch) => {
    try {
      const params = new URLSearchParams({ page });
      if (department) params.append("department", department);
      const res = await axios.get(
        `/api/file-transfer/list-files/all/?${params.toString()}`
      );

      dispatch({
        type: GET_FILES_SUCCESS,
        payload: res.data,
      });

      return res.data;
    } catch (err) {
      console.error(
        "File list retrieval failed:",
        err.response?.data || err.message
      );

      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: GET_FILES_FAILED,
      });

      throw err;
    }
  };

export const uploadFolder = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/file-transfer/folder/upload/`,
      formData,
      config
    );

    dispatch({
      type: FOLDER_UPLOAD_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    console.error("Folder upload failed:", err.response?.data || err.message);

    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: FOLDER_UPLOAD_FAILED,
    });
    throw err;
  }
};

export const ingestFolder = (folderId) => async (dispatch) => {
  try {
    dispatch({
      type: IS_FOLDER_INGESTING,
      payload: true,
    });

    const res = await axios.post(
      `/api/file-transfer/folder/ingest/${folderId}/`
    );

    dispatch({
      type: FOLDER_INGESTION_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    console.error(
      "Folder ingestion failed:",
      err.response?.data || err.message
    );

    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: FOLDER_INGESTION_FAILED,
    });
    throw err;
  } finally {
    dispatch({
      type: IS_FOLDER_INGESTING,
      payload: false,
    });
  }
};

export const resetFolderIngestion = () => async (dispatch) => {
  dispatch({
    type: FOLDER_INGESTION_STATE_RESET,
  });
};

export const deleteFile = (fileId) => async (dispatch) => {
  try {
    await axios.delete(`/api/file-transfer/delete/${fileId}/`);
    dispatch({ type: DELETE_FILE_SUCCESS, payload: fileId });
    return { success: true };
  } catch (err) {
    console.error("File delete failed:", err.response?.data || err.message);
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: DELETE_FILE_FAILED });
    throw err;
  }
};

export const deleteDocument = (payload) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/file-transfer/documents/delete/`, payload);
    dispatch({ type: DELETE_DOCUMENT_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    console.error("Document delete failed:", err.response?.data || err.message);
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: DELETE_DOCUMENT_FAILED });
    throw err;
  }
};

export const replaceDocument = (formData) => async (dispatch) => {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  try {
    const res = await axios.post(`/api/file-transfer/documents/replace/`, formData, config);
    dispatch({ type: REPLACE_DOCUMENT_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    console.error("Document replace failed:", err.response?.data || err.message);
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: REPLACE_DOCUMENT_FAILED });
    throw err;
  }
};


export const fetchProcessingStatus = () => async (dispatch) => {
  try {
    const res = await axios.get(`/api/file-transfer/processing-status/`);
    return res.data;
  } catch (err) {
    console.error("fetchProcessingStatus failed:", err.response?.data || err.message);
    return { processing: [] };
  }
};

export const downloadFile = (fileName) => async () => {
  const res = await axios.get(
    `/api/file-transfer/download-by-name/?file_name=${encodeURIComponent(fileName)}`,
    { responseType: "blob" }
  );
  const contentDisposition = res.headers["content-disposition"] || "";
  const match = contentDisposition.match(/filename="?([^"]+)"?/);
  const name = match ? match[1] : fileName;
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const fetchDepartments = () => async () => {
  try {
    const res = await axios.get("/api/file-transfer/departments/");
    return res.data;
  } catch (err) {
    console.error("Fetch departments failed:", err.response?.data || err.message);
    return { departments: [] };
  }
};

export const fetchAuditLog = (page, pageSize) => async (dispatch) => {
  try {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (pageSize) params.append("page_size", pageSize);
    const query = params.toString();
    const res = await axios.get(`/api/file-transfer/audit-log/${query ? `?${query}` : ""}`);
    return res.data;
  } catch (err) {
    console.error("Fetch audit log failed:", err.response?.data || err.message);
    dispatch(returnErrors(err.response?.data, err.response?.status));
  }
};
